import React from 'react';
import { Link } from 'react-router-dom';
import { cvePath, hostPath, imagePath, packagePath } from './entityRoutes';

const LINK_CLASS = 'inline-block max-w-full truncate align-bottom font-mono text-id text-signal hover:underline';

/**
 * kind="cve":     cve
 * kind="package": name, id?
 * kind="host":    id, name
 * kind="image":   id?, name (title shows `title` when given, e.g. the full image key)
 */
export default function EntityLink({ kind, cve, id, name, title, className = '' }) {
  if (kind === 'cve') {
    return (
      <Link to={cvePath(cve)} className={`${LINK_CLASS} ${className}`} title={cve}>
        {cve}
      </Link>
    );
  }

  if (kind === 'package') {
    return (
      <Link to={packagePath({ id, name })} className={`${LINK_CLASS} ${className}`} title={name}>
        {name}
      </Link>
    );
  }

  if (kind === 'host') {
    return (
      <Link to={hostPath({ id, name })} className={`${LINK_CLASS} ${className}`} title={name}>
        {name}
      </Link>
    );
  }

  if (kind === 'image') {
    return (
      <Link to={imagePath({ id, name })} className={`${LINK_CLASS} ${className}`} title={title || name}>
        {name}
      </Link>
    );
  }

  return null;
}
